export class Settings {
    public static urlAPi:string='http://192.168.1.100/transmdicas/api/';
    public static UrlWeb:string='http://192.168.1.100/transmdicas/web/';
}
